<template>
    <div style="width:100%">
        <div style="padding:20px">
            <p>问题详情</p>
            <div class="item">
                <span>主题</span>
                <el-input type="text" v-model="editForm.question_subject"></el-input>
            </div>
            <div class="item">
                <span>年份</span>
                <el-input type="text" v-model="editForm.question_year"></el-input>
            </div>
            <div class="item">
                <span>等级</span>
                <el-input type="text" v-model="editForm.question_level"></el-input>
            </div>
            <div class="item">
                <span>考点</span>
                <el-input type="text" v-model="editForm.question_competency"></el-input>
            </div>
            <div class="item">
                <span>分值</span>
                <el-input type="number" min="0" v-model="editForm.question_marks"></el-input>
            </div>
            <div class="item">
                <span>组</span>
                <el-input type="text" v-model="editForm.question_group" placeholder="同一组题目用于考试时打乱题序"></el-input>
            </div>
            <div class="item">
                <span>对应材料</span>
                <el-select
                  v-model="editForm.question_article"
                  filterable
                  clearable
                  placeholder="选择材料（如 M1），可留空"
                  style="width: 80%; margin-left: 10px"
                >
                  <el-option
                    v-for="item in articleOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
            </div>
            <div class="item">
                <p>题目</p>
                <Tinymce key="add-question-main-editor" id="add-question-main-editor" v-model="editForm.question_question" :height="240"></Tinymce>
            </div>
            <template v-if="editForm.question_type === 'select'">
              <div
                v-for="option in optionLetters"
                :key="'add-option-' + option"
                class="item"
              >
                <p>选项{{ option }}</p>
                <div class="option-version-row">
                  <div class="option-version-item">
                    <p>Version A</p>
                    <Tinymce
                      :key="'add-question-option-' + option.toLowerCase() + '-editor'"
                      :id="'add-question-option-' + option.toLowerCase() + '-editor'"
                      v-model="editForm['question_option' + option]"
                      :height="180"
                    ></Tinymce>
                  </div>
                  <div class="option-version-item">
                    <p>Version B</p>
                    <Tinymce
                      :key="'add-question-option-' + option.toLowerCase() + '-version-b-editor'"
                      :id="'add-question-option-' + option.toLowerCase() + '-version-b-editor'"
                      v-model="editForm['question_option' + option + '_versionB']"
                      :height="180"
                    ></Tinymce>
                  </div>
                </div>
              </div>
              <div class="item">
                  <span>答案</span>
                  <el-select v-model="editForm.question_answer" style="margin-left:10px">
                    <el-option label="A" value="A"></el-option>
                    <el-option label="B" value="B"></el-option>
                    <el-option label="C" value="C"></el-option>
                    <el-option label="D" value="D"></el-option>
                    <el-option label="E" value="E"></el-option>
                  </el-select>
              </div>
            </template>

            <div class="item" style="margin-top: 10px">
                <span>题目类型</span>
                <el-select v-model="editForm.question_type" style="margin-left:10px">
                <el-option label="选择题" value="select"></el-option>
                <el-option label="问答题" value="input"></el-option>
                </el-select>
            </div>

            <div v-if="editForm.question_type === 'input'" class="essay-config">
              <div class="item" style="margin-top: 10px">
                <span>最大单词数</span>
                <el-input
                    type="number"
                    min="1"
                    v-model="editForm.question_input_restrict"
                ></el-input>
              </div>
              <div class="item">
                <p>参考答案</p>
                <Tinymce key="add-question-reference-answer-editor" id="add-question-reference-answer-editor" v-model="editForm.question_reference_answer" :height="180"></Tinymce>
              </div>
              <div class="item">
                <p>AI 评分标准</p>
                <Tinymce key="add-question-scoring-rubric-editor" id="add-question-scoring-rubric-editor" v-model="editForm.question_scoring_rubric" :height="220"></Tinymce>
              </div>
              <el-alert
                  title="问答题交卷后进入异步 AI 评分；参考答案或评分标准至少填写一项。"
                  type="info"
                  :closable="false">
              </el-alert>
            </div>

            <div style="margin-top:20px;margin-bottom:20px">
                <el-button type="primary" :loading="saving" @click="submit">提交</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { updateExerciseQuestion, addExerciseQuestionToTemplateSection, getExerciseTemplate } from '../api/examAdmin'
import Tinymce from '../components/Tinymce'
import { buildHtmlMaterialOptions } from '../utils/htmlMaterials'
export default {
  components: {
    Tinymce
  },
  data () {
    return {
      question_id: '',
      section_id: this.$route.query.section_id,
      template_id: this.$route.query.template_id || '',
      saving: false,
      optionLetters: ['A', 'B', 'C', 'D', 'E'],
      articleOptions: [],
      editForm: {
        _id: {
          $id: ''
        },
        question_subject: '',
        question_year: '',
        question_level: '',
        question_competency: '',
        question_question: '',
        question_optionA: '',
        question_optionB: '',
        question_optionC: '',
        question_optionD: '',
        question_optionE: '',
        question_optionA_versionB: '',
        question_optionB_versionB: '',
        question_optionC_versionB: '',
        question_optionD_versionB: '',
        question_optionE_versionB: '',
        question_answer: '',
        question_marks: 0,
        question_type: 'select',
        question_input_restrict: 200,
        question_reference_answer: '',
        question_scoring_rubric: '',
        question_group: '',
        question_article: ''
      }
    }
  },
  mounted () {
    this.loadArticleOptions()
  },
  methods: {
    loadArticleOptions () {
      if (!this.template_id) {
        this.articleOptions = []
        return
      }
      getExerciseTemplate(this.template_id).then(res => {
        if (res.data.code !== 0) {
          return
        }
        const materials = (res.data.data && res.data.data.html_materials) || []
        this.articleOptions = buildHtmlMaterialOptions(materials)
      }).catch(() => {
        this.articleOptions = []
      })
    },
    updateExerciseQuestion () {
      return updateExerciseQuestion(this.question_id,
        this.editForm.question_subject,
        this.editForm.question_year,
        this.editForm.question_level,
        this.editForm.question_competency,
        this.editForm.question_question,
        this.editForm.question_optionA,
        this.editForm.question_optionB,
        this.editForm.question_optionC,
        this.editForm.question_optionD,
        this.editForm.question_optionE,
        this.editForm.question_answer,
        '',
        [],
        this.editForm.question_marks,
        this.editForm.question_type,
        this.editForm.question_input_restrict,
        this.editForm.question_reference_answer,
        this.editForm.question_scoring_rubric,
        this.editForm.question_group,
        this.editForm.question_article,
        this.editForm.question_optionA_versionB,
        this.editForm.question_optionB_versionB,
        this.editForm.question_optionC_versionB,
        this.editForm.question_optionD_versionB,
        this.editForm.question_optionE_versionB
      )
    },
    addExerciseQuestionToTemplateSection (question_id) {
      return addExerciseQuestionToTemplateSection(question_id, this.section_id).then(res => {
        if (res.data && res.data.code === 0) {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
        } else {
          this.$message('已添加')
        }
      })
    },
    async submit () {
      if (this.saving) {
        return
      }

      if (this.editForm.question_type === 'select' && !this.editForm.question_answer) {
        this.$message.error('请选择答案')

        return
      }

      if (this.editForm.question_type === 'input') {
        const limit = parseInt(this.editForm.question_input_restrict, 10)
        if (!limit || limit < 1) {
          this.$message.error('请输入有效的最大单词数')
          return
        }
        if (!this.hasText(this.editForm.question_reference_answer) && !this.hasText(this.editForm.question_scoring_rubric)) {
          this.$message.error('参考答案或 AI 评分标准至少填写一项')
          return
        }
      }

      const isCreating = !this.question_id
      this.saving = true

      try {
        const result = await this.updateExerciseQuestion()
        if (result.data.code !== 0) {
          this.$message.error(result.data.msg || '保存失败，请稍后重试')
          return
        }

        if (isCreating) {
          const savedId = this.getSavedQuestionId(result.data.data)
          if (!savedId) {
            this.$message.error('题目已保存，但服务器未返回题目 ID，请刷新后重试')
            return
          }
          this.question_id = savedId
          await this.addExerciseQuestionToTemplateSection(savedId)
          this.$router.replace({
            path: '/questionInfo',
            query: {
              question_id: savedId,
              ...(this.template_id ? { template_id: this.template_id } : {})
            }
          }).catch(() => {})
        } else {
          this.$message.success('更新成功')
        }
      } catch (error) {
        this.$message.error('保存失败，请检查网络后重试')
      } finally {
        this.saving = false
      }
    },
    getSavedQuestionId (question) {
      if (!question || !question._id) {
        return ''
      }
      if (typeof question._id === 'string') {
        return question._id
      }
      return question._id.$id || question._id.$oid || ''
    },
    hasText (html) {
      const node = document.createElement('div')
      node.innerHTML = html || ''
      return (node.textContent || node.innerText || '').trim().length > 0
    }
  }

}
</script>

<style scoped>
.item{
    margin-top:20px
}
.item .el-input{
    width: 80%;
    margin-left: 10px;
}
.option-version-row {
  display: flex;
  gap: 16px;
}
.option-version-item {
  flex: 1;
  min-width: 0;
}
</style>
